'use client';

import { c as _c } from "react/compiler-runtime";
import { AppImage } from '@/app/components/media/app-image';
import type { SpartanProductFeatureShowcaseMediaProps } from '@/app/lcv/components/sections/spartan/products/feature-showcase/panel/media/types';
import { cn } from '@/app/utils/cn';
export const SpartanProductFeatureShowcaseMedia = t0 => {
  const $ = _c(12);
  const {
    src,
    alt,
    width,
    height,
    sizes,
    className,
    testId
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("bg-silver-100 relative overflow-hidden rounded-lg", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== alt || $[3] !== height || $[4] !== sizes || $[5] !== src || $[6] !== testId || $[7] !== width) {
    t2 = <AppImage src={src} alt={alt} width={width} height={height} sizes={sizes} className="size-full" testId={testId} />;
    $[2] = alt;
    $[3] = height;
    $[4] = sizes;
    $[5] = src;
    $[6] = testId;
    $[7] = width;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};